<template>
  <q-layout view="hhh Lpr lff">
    <q-page-container>
      <q-page class="layout-padding">
        <h4>Оплата за допомогою Приват24</h4>

        <div>
          Для оплати через Приват24 перейдіть до розділу «Сервіси» → <a
          href="https://next.privat24.ua/payments">«Платежі»</a> і введіть у рядок пошуку контрагента:
          <ul>
            <li>номер рахунку <strong>«{{ checkingAccount }}»</strong></li>
            <li v-if="companyName">або назву компанії <strong>«{{ companyName }}»</strong></li>
            <li v-if="edrpou">або ЄДРПОУ <strong>«{{ edrpou }}»</strong></li>
          </ul>
        </div>
        <div class="row inline justify-center" style="margin-bottom: 15px;">
          <picture>
            <img
              sizes="(max-width: 791px) 100vw, 791px"
              srcset="
                /img/privat24/mob_instructions4.png 200w,
                /img/privat24/mob_instructions4.png 425w,
                /img/privat24/mob_instructions4.png 599w,
                /img/privat24/mob_instructions4.png 720w"
              src="/img/privat24/mob_instructions4.png"
              alt="">
          </picture>
        </div>
        <div class="row">
          <p>І далі заповніть форму, обов'язково вкажіть номер рахунку <strong>«{{ billNumber }}»</strong>.</p>
        </div>
        <br>
        <div class="row inline justify-center" style="margin-bottom: 15px;">
          <picture>
            <img
              sizes="(max-width: 779px) 100vw, 779px"
              srcset="
                /img/privat24/mob_instructions5.png 200w,
                /img/privat24/mob_instructions5.png 425w,
                /img/privat24/mob_instructions5.png 599w,
                /img/privat24/mob_instructions5.png 720w"
              src="/img/privat24/mob_instructions5.png"
              alt="">
          </picture>
        </div>
        <br>
        <div class="row">
          <p>Або через мобільний додаток перейдіть до розділу «Сервіси» → «Платежі» та введіть у рядок пошуку <br>
            номер рахунку <strong>«{{ checkingAccount }}»</strong>, після чого заповніть форму:</p>
        </div>
        <div class="row inline justify-center">
          <picture>
            <img
              sizes="(max-width: 720px) 100vw, 720px"
              srcset="
                /img/privat24/mob_instructions1.jpg 200w,
                /img/privat24/mob_instructions1.jpg 425w,
                /img/privat24/mob_instructions1.jpg 599w,
                /img/privat24/mob_instructions1.jpg 720w"
              src="/img/privat24/mob_instructions1.jpg"
              alt="Мобильная инстукция">
          </picture>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
  import {
    QLayout,
    QPageContainer,
    QPage
  } from 'quasar';

  export default {
    name: 'Privat24View',
    components: {
      QPage,
      QPageContainer,
      QLayout
    },

    data () {
      return {
        bill: {
          number: null,
          created_at: null,
          amount: null,
          destination: '',
          project: {
            service_code: ''
          }
        },
        serviceProvider: null,
        requisites: {
          edrpou: '',
          checking_account: '',
          company_name: ''
        }
      };
    },

    computed: {
      edrpou () {
        return this.requisites.edrpou;
      },
      companyName () {
        return this.requisites.company_name;
      },
      checkingAccount () {
        return this.requisites.checking_account;
      },
      billNumber () {
        return this.bill.number;
      }
    },

    mounted () {
      this.fetchBill(this.$route.params.id, this.$route.query.token);
    },

    methods: {
      fetchBill (billId, token) {
        return this.$http.get(`api/v1.0/bill-info/${billId}?token=${token}`).then(response => {
          if(response.data.error){
            this.$q.notify({message: response.data.error,});
            return;
          }

          this.bill = response.data.bill;
          this.serviceProvider = response.data.service_provider;
          Object.assign(this.requisites, this.getPrivatRequisites(this.serviceProvider));
        });
      },

      getPrivatRequisites (serviceProvider) {
        const method = serviceProvider.payment_details.find(row => row.payment_method === 'privat24');

        if (!method) {
          return;
        }

        return method.requisites;
      }
    }
  };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/Privat24View.vue